import { render, staticRenderFns } from "./Airsoft.vue?vue&type=template&id=503390f2&"
import script from "./Airsoft.vue?vue&type=script&lang=js&"
export * from "./Airsoft.vue?vue&type=script&lang=js&"
import style0 from "./Airsoft.vue?vue&type=style&index=0&id=503390f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports